module.exports = __webpack_public_path__ + "static/media/NOBA_Spotlight.a1377795.svg";